//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
export default {
  name: "login",
  data() {
    return {
      userid: "", //用户id
      password: "", //用户账号
      logintype: 1, //登录账号类型
      url: "api/api/portalLogin/loginAccount",
      emailTip: "Enter Email",
      passwordTip: "Enter Password",
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = this.$isMobile();
  },
  methods: {
    setLogintype(str) {
      this.userid = "";
      this.password = "";
      this.logintype = str;
      if (str == "1") {
        this.emailTip = "Enter Email";
        this.passwordTip = "Enter Password";
      } else if (str == "2") {
        this.emailTip = "Enter EID / User Code / DITO Email / Phone No.";
        this.passwordTip = "Enter MSS Portal Password";
      }
    },
    forgetPassword() {
      this.$router.push("/portal/retrievePassword");
    },
    signUpPage() {
      this.$router.push("/portal/signUp");
    },
    async submitlogin() {
      //点击登录
      if (this.userid.length <= 0) {
        this.$msgDailog.showMsgBox({
          title: "Account or Password cannot be empty.",
        });
        return false;
      }
      if (this.password.length <= 0) {
        this.$msgDailog.showMsgBox({
          title: "Account or Password cannot be empty.",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(this.logintype)) {
        this.$msgDailog.showMsgBox({
          title:
            "Please select your role (External Candidate or DITO Employee).",
        });
        return false;
      }
      let params = {
        userid: this.userid,
        logintype: this.logintype,
        password: this.password,
      };
      if (this.logintype == "2") {
        let newPassword = this.jsEncodePwd(this.password);
        params.password = newPassword;
      }

      await axios.post(this.url, params).then(({ data }) => {
        if (data.code == "1") {
          let msg = data.data.msg;
          if (this.isNotNullOrEmpty(msg)) {
            this.$msgDailog.showMsgBox({
              title: msg,
            });
            return;
          }
          auth.setToken(data.data.ffToken);
          //登录成功后跳转到JOB页面
          this.$router.push({
            path: "/portal/portList",
            query: {},
          });
        }
      });
    },
    jsEncodePwd: function (pwd) {
      let bytes = this.strToUtf8Bytes(pwd);
      return this.encodeBytes(bytes);
    },

    /**
     * 字符串转化为utf8字节数组
     * @param str
     * @returns {Array}
     */
    strToUtf8Bytes: function (str) {
      // TODO(user): Use native implementations if/when available
      var out = [],
        p = 0;
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
          out[p++] = c;
        } else if (c < 2048) {
          out[p++] = (c >> 6) | 192;
          out[p++] = (c & 63) | 128;
        } else if (
          (c & 0xfc00) == 0xd800 &&
          i + 1 < str.length &&
          (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00
        ) {
          // Surrogate Pair
          c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
          out[p++] = (c >> 18) | 240;
          out[p++] = ((c >> 12) & 63) | 128;
          out[p++] = ((c >> 6) & 63) | 128;
          out[p++] = (c & 63) | 128;
        } else {
          out[p++] = (c >> 12) | 224;
          out[p++] = ((c >> 6) & 63) | 128;
          out[p++] = (c & 63) | 128;
        }
      }
      return out;
    },

    /**
     * 转化字节数组为字符串，每个字节的高4位和低4位+字符a组成2个ascii字符.
     * @param bytes
     * @returns {string}
     */
    encodeBytes: function (bytes) {
      var re = [];
      for (var i = 0; i < bytes.length; i++) {
        var ch1 = String.fromCharCode(((bytes[i] >> 4) & 0xf) + 0x61);
        var ch2 = String.fromCharCode((bytes[i] & 0xf) + 0x61);
        re.push(ch1);
        re.push(ch2);
      }
      return re.join("");
    },
  },
  created() {
    // this.setLogintype(1)
    /**this.$msgDailog.showMsgBox({
              title:"There is a problem with data storage. please try again later."
            }).then(async (val) => {
              console.log(val);
            }).catch(() => {
              console.log("点击取消");
            });**/
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/login.vue